module.exports = "/js/dist/images/purchase/disk_sml.png";


//////////////////
// WEBPACK FOOTER
// ./images/purchase/disk_sml.png
// module id = 280
// module chunks = 1